import React, { useContext } from 'react';

import Permissions from '@/lib/permissions';
import AppPage from '@/ui/AppPage/AppPage';
import DataCentricPage from '@/ui/DataCentric/DataCentricPage';
import Korisnici from '@/models/groblja/korisnici';
import DataController from '@/lib/DataController';
import DialogContext from '@/context/DialogContext/DialogContext';
import GeneralTableDialog from '@/ui/Dialog/GeneralTableDialog';
import AdvancedGrobljaDialog from './AdvancedGrobljaDialog';
import { AllowRowActionFn } from '@/@types/ui/Table';
import { DCRecord } from '@/@types/lib/dataController';
import GMKorisnici from '@/models/groblja/grobno_mjesto_korisnici';
import GeneralGrobljaDialog from '../GeneralGrobljaDialog';

const RegistarKorisnikaDataCentricPage = () => {
  const dc = new DataController(Korisnici);
  const dcGm = new DataController(GMKorisnici);

  const { showDialog } = useContext(DialogContext);

  const handleRowAction: (action: string, id: number, record?: { [key: string]: any }) => void = (action, id) => {
    if (action === 'show_history') {
      showDialog(GeneralTableDialog, {
        mode: 'view',
        dc,
        onClose: () => {},
        level: 1,
        title: 'groblja:titles.korisnici_history',
        view: 'history',
        customPath: `${Korisnici.apiPath}/${id}/history`,
        tableId: 'korisnici-history',
      });
    }
  };

  const handleSecondaryRowAction: (action: string, id: number, record?: { [key: string]: any }) => void = (action, id, record) => {
    if (action === 'show_history') {
      showDialog(GeneralTableDialog, {
        mode: 'view',
        dc: dcGm,
        onClose: () => {},
        level: 1,
        title: 'groblja:titles.gm_korisnici_history',
        view: 'korisnici_grobno_mjesto_history',
        customPath: `${Korisnici.apiPath}/${record?.osoba_id}/grobna-mjesta/${id}/history`,
        tableId: 'korisnici-grobna-mjesta-history',
      });
    }
  };

  const allowRowAction: AllowRowActionFn = (action: string, record: DCRecord) => {
    if (action === 'show_history' && record.has_history) {
      return true;
    }
    return false;
  };

  return (
    <AppPage titlett="groblja:titles.reg_korisnika" needPermission={[Permissions.GrobljaManageOsnovniRegistri]}>
      <DataCentricPage
        tableIdentifier="reg_korisnika"
        primaryModel={Korisnici}
        primaryTitleToken="groblja:titles.reg_korisnika"
        primaryView="default"
        primaryDialogComponent={GeneralGrobljaDialog}
        primaryAllowEdit
        primaryAllowAdd
        primaryAllowExport
        secondaryModel={GMKorisnici}
        secondaryTitleToken="groblja:titles.gm_korisnici"
        secondaryView="korisnici_grobno_mjesto"
        secondaryDialogComponent={AdvancedGrobljaDialog}
        secondaryAllowEdit
        secondaryAllowAdd
        secondaryAllowColumnPicker
        baseRecordPath={Korisnici.apiPath}
        // secondaryBaseRecordPath={`system/${modelComments.apiPath}/entity`}
        // primaryQueryAttribute="entity_gid"
        childRecordRelativePath="grobna-mjesta"
        foreignKeyField="osoba_id"
        geomRelativePath=""
        allowShowImages={false}
        mapId={45}
        mapModel={Korisnici}
        allowCustomTableAction={allowRowAction}
        onCustomTableAction={handleRowAction}
        primaryAllowShowDeleted
        allowShowSecondaryOnMap
        autoSelectSecondaryFromMapFeatureId
        replacePrimaryIdInSecondaryPath
        secondaryAllowShowDeleted
        secondaryAllowCustomTableAction={allowRowAction}
        secondaryOnCustomTableAction={handleSecondaryRowAction}
        secondaryAllowDocumentButton
      />
    </AppPage>
  );
};

export default RegistarKorisnikaDataCentricPage;
